import { useEffect, useState } from "react";

export function useYouTubeTitle(videoUrl: string): string {
    const [title, setTitle] = useState("Video Slide");

    useEffect(() => {
        if (!videoUrl?.trim()) return;

        fetch(`https://www.youtube.com/oembed?url=${encodeURIComponent(videoUrl)}&format=json`)
            .then((res) => res.json())
            .then((data) => {
                if (data?.title) setTitle(data.title);
            })
            .catch(() => {});
    }, [videoUrl]);

    return title;
}